<template>
  <v-footer class="d-print-none mt-2" color="white" padless>
    <v-row justify="center" no-gutters>
      <v-btn small text :href="contactMailTo" target="_blank">
        Contact Us
      </v-btn>
      <v-btn small text :href="termsUrl" target="_blank">
        Terms and Conditions
      </v-btn>
      <v-btn small text :href="privacyPolicyUrl" target="_blank">
        Our Privacy Policy
      </v-btn>
      <v-col class="pb-2 caption text-center" cols="12">
        &copy; {{ new Date().getFullYear() }} NCAA
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      privacyPolicyUrl: "http://web1.ncaa.org/web_files/privacy.html",
      termsUrl: "http://web1.ncaa.org/web_files/terms_and_conditions.html",
      contactUsEmail: "contactus@ncaa.org",
    };
  },
  computed: {
    contactMailTo() {
      return `mailto:${this.contactUsEmail}`;
    },
  },
};
</script>
